import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const getProducts = async () => {
  try {
    const response = await axios.get(`${API}/products`);
    return response.data.products;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// Testimonials API
export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data.testimonials;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// FAQs API
export const getFAQs = async () => {
  try {
    const response = await axios.get(`${API}/faqs`);
    return response.data.faqs;
  } catch (error) {
    console.error('Error fetching FAQs:', error);
    throw error;
  }
};

// Newsletter API
export const subscribeNewsletter = async (email) => {
  try {
    const response = await axios.post(`${API}/newsletter/subscribe`, { email });
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
